import { render, staticRenderFns } from "./partnersDeposits.vue?vue&type=template&id=35d374d4"
import script from "./partnersDeposits.vue?vue&type=script&lang=js"
export * from "./partnersDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports